import React from "react";
import { Table } from "antd";

import styles from "./TabelaRelatorioAluno.module.scss";

const gerarColunas = () => [
    {
        title: "Avaliação",
        dataIndex: "nome",
        key: "nome",
        width: "60%",
        render: (text, record) => {
            if (record.nome === "Disciplina") {
                return {
                    children: <strong>Disciplina: {record.nota}</strong>,
                    props: {
                        colSpan: 2
                    }
                };
            }

            return <span>{text}</span>;
        }
    },
    {
        title: "Nota",
        dataIndex: "nota",
        key: "nota",
        width: "40%",
        align: "center",
        render: (text, record) => {
            if (record.nome === "Disciplina") {
                return { props: { colSpan: 0 } };
            }

            const isMedia = record.nome === "Média Bimestral" || record.nome === "Média Anual";
            const isEstado = record.nome === "Estado";

            const notaNumerica = parseFloat(text?.replace(",", "."));
            const isNotaNumericaValida = !isNaN(notaNumerica);
            const valor = text || "-";

            if (isEstado) {
                if (text === "Aprovado" || text === "Reprovado") {
                    return <div className={`${styles.fundoCelula} ${text === "Aprovado" ? styles.aprovado : styles.reprovado}`}>{text}</div>;
                } else {
                    return <span>-</span>;
                }
            }

            if (isMedia && isNotaNumericaValida) {
                return <div className={`${styles.fundoCelula} ${notaNumerica >= 6 ? styles.aprovado : styles.reprovado}`}>{text}</div>;
            }

            return valor;
        }
    }
];

const transformarParaDataSource = disciplina => {
    const data = [
        {
            key: `disciplina-header-${disciplina.disciplina}`,
            nome: "Disciplina",
            nota: disciplina.disciplina
        },
        ...disciplina.avaliacoes.map((av, index) => ({
            key: `av-${index}`,
            nome: av.nome,
            nota: av.nota
        }))
    ];

    const media = disciplina.avaliacoes.find(av => av.nome === "Média Bimestral" || av.nome === "Média Anual");

    const mediaNum = parseFloat(media?.nota?.replace(",", "."));
    const estado = isNaN(mediaNum) ? "-" : mediaNum >= 6 ? "Aprovado" : "Reprovado";

    data.push({
        key: "estado",
        nome: "Estado",
        nota: estado
    });

    return data;
};

const TabelaRelatorioAlunoMobile = ({ dynamicColumns, disciplinas }) => {
    if (!disciplinas || disciplinas.length === 0) return null;

    const columns = gerarColunas();

    return (
        <div className={styles.listaMobile}>
            {disciplinas.map((disciplina, index) => (
                <div key={index} className={styles.disciplinaMobile}>
                    <Table
                        className={styles.tabela}
                        columns={columns}
                        dataSource={transformarParaDataSource(disciplina)}
                        pagination={false}
                        showHeader={false}
                        bordered
                        size="small"
                    />
                </div>
            ))}
        </div>
    );
};

export default TabelaRelatorioAlunoMobile;
